import { FlexBox } from '@ardoq/layout';
import { SearchColumnGroup } from './SearchColumnGroup';
import {
  ComponentSelectedInteractiveRowViewState,
  InventoryInteractiveTopRowCommands,
} from './types';
import { Text } from '@ardoq/typography';
import { MoreVertIcon } from '@ardoq/icons';
import { Button, ButtonType, GhostButton } from '@ardoq/button';
import { pluralize } from '@ardoq/common-helpers';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { VisualizeButton } from './VisualizeButton';
import { toComponentIdAndTypeName } from '@ardoq/core';
import { type I18nLocale, t } from '@ardoq/i18n';
import { inventoryDatasourceOperations } from '../datasourceOperations';
import { TableControlsInteractiveRow } from './TableControlsInteractiveRow';

type SelectionInteractiveTopRowProps = {
  state: ComponentSelectedInteractiveRowViewState;
  i18nLocale: I18nLocale;
};
export const SelectionInteractiveTopRow = ({
  state,
  commands,
  i18nLocale,
}: SelectionInteractiveTopRowProps & {
  commands: InventoryInteractiveTopRowCommands;
}) => (
  <TableControlsInteractiveRow i18nLocale={i18nLocale}>
    <SearchColumnGroup
      state={state}
      commands={commands}
      i18nLocale={i18nLocale}
    />
    <FlexBox gap="xsmall" align="center">
      <Text variant="text2" color="textSubtle">
        {t(
          i18nLocale,
          'inventory:interactiveRow.componentSelected',
          { count: state.selectedComponents.length },
          `${state.selectedComponents.length} ${pluralize('component', state.selectedComponents.length)} selected`
        )}
      </Text>
      <FlexBox gap="xsmall" align="center">
        <GhostButton
          onClick={commands.deselectAllRows}
          isDisabled={state.selectedComponents.length === 0}
        >
          {t(i18nLocale, 'inventory:interactiveRow.cancel', 'Cancel')}
        </GhostButton>
        {!state.isUserContributor && (
          <ButtonWithDropdown
            buttonType={ButtonType.TERTIARY}
            hideChevron
            options={state.moreButtonOptions}
          >
            <MoreVertIcon />
          </ButtonWithDropdown>
        )}
        {inventoryDatasourceOperations.isDatasetInventoryDatasourceSelection(
          state.datasourceSelection
        ) ? (
          // This is temporary and should be moved into a separate component
          // to reduce duplication when this is no longer a POC
          <Button
            onClick={commands.goBackToVisualization}
            buttonType={ButtonType.PRIMARY}
          >
            {t(
              i18nLocale,
              'inventory:interactiveRow.backToVisualization',
              'Back to Visualization'
            )}
          </Button>
        ) : (
          <VisualizeButton
            selectedCount={state.selectedComponents.length}
            visualizeButtonOptions={state.visualizeButtonOptions}
            totalNumberOfRows={state.totalNumberOfMatchingRows}
            isUserContributor={state.isUserContributor}
            openOverviewViewpoint={() =>
              commands.openOverviewViewpoint(
                toComponentIdAndTypeName(state.selectedComponents)
              )
            }
            i18nLocale={i18nLocale}
          />
        )}
      </FlexBox>
    </FlexBox>
  </TableControlsInteractiveRow>
);
